import { useReactiveVar } from '@apollo/client'
import { useEffect } from 'react'
import styled from 'styled-components'
import { TokenTypeEnum, tokenTypeFilterVar } from '../../../graphql/variables/SharedVariable'
import { accountVar } from '../../../graphql/variables/WalletVariable'
import { useLocalStorage } from '../../../hooks/LocalStorageHooks'
import { useRouteParams, useRouteTokenType } from '../../../hooks/RouteHooks'
import SelectFilter from '../../design-system/SelectFilter'
import TagButton from '../buttons/TagButton'

interface TokenTypeFilterProps {
  account: string
}

export default function TokenTypeFilter({ account }: TokenTypeFilterProps) {
  const { setItem } = useRouteParams()
  const handleLocalStorage = useLocalStorage()
  const walletAddress = useReactiveVar(accountVar)

  const setFilter = (item: string) => {
    setItem('tokenType', item)
    handleLocalStorage.setItem('tokenType', item)
  }

  const types = [
    {
      id: TokenTypeEnum.collection,
      name: 'Collections',
      action() {
        setFilter(TokenTypeEnum.collection)
      }
    },
    {
      id: TokenTypeEnum.listed,
      name: 'Listed',
      action() {
        setFilter(TokenTypeEnum.listed)
      }
    },
    {
      id: TokenTypeEnum.fractions,
      name: 'Fractions',
      action() {
        setFilter(TokenTypeEnum.fractions)
      }
    },
    {
      id: TokenTypeEnum.pools,
      name: 'Pools',
      action() {
        setFilter(TokenTypeEnum.pools)
      }
    }
  ]

  walletAddress?.toLocaleLowerCase() === account.toLocaleLowerCase() &&
    types.push({
      id: TokenTypeEnum.privatePools,
      name: 'Private Pools',
      action() {
        setFilter(TokenTypeEnum.privatePools)
      }
    })

  const routerType = useRouteTokenType()

  useEffect(() => {
    handleLocalStorage.setItem('tokenType', routerType)
  }, [handleLocalStorage, routerType])

  useEffect(() => {
    if (routerType) {
      tokenTypeFilterVar([routerType])
    }
  }, [routerType])

  return (
    <Container>
      <Desktop>
        {types.map(item => (
          <TagButton key={item.id} name={item.name} onClick={() => setFilter(item.id)} active={routerType === item.id} />
        ))}
      </Desktop>
      <Mobile>
        <SelectFilter width={130} data={types} value={routerType || TokenTypeEnum.collection} />
      </Mobile>
    </Container>
  )
}

const { Container, Desktop, Mobile } = {
  Container: styled.div`
    display: grid;
    grid-template-columns: repeat(5, auto);
    gap: 10px;
    justify-content: start;
  `,
  Desktop: styled.div`
    display: none;

    @media (min-width: ${props => props.theme.viewport.desktop}) {
      display: grid;
      grid-template-columns: auto auto auto auto auto;
      gap: 10px;
      justify-content: end;
    }
  `,
  Mobile: styled.div`
    width: 100%;

    @media (min-width: ${props => props.theme.viewport.desktop}) {
      display: none;
    }
  `
}
